import { useEffect, useState } from 'react';
import { EntryFieldConfig } from '../../../interfaces/entityInbodyData';
import {
  INBODY_TYPES,
  InbodyType,
} from '../../../../shared/constants/inbody-info/InbodyType';
import { inbodyEntryFieldConfig } from '../../../constants/inbodyEntryFieldConfig';
import { inbodyDataService } from '../../../services/inbodyDataService';

type UseScanConfigParams = {
  inBodyType: InbodyType;
  entityId: number;
};

type UseScanConfigReturn = {
  addScanConfig: EntryFieldConfig | null;
  scanConfigLoading: boolean;
};

export const useScanConfig = ({
  inBodyType,
  entityId,
}: UseScanConfigParams): UseScanConfigReturn => {
  const [scanConfigLoading, setScanConfigLoading] = useState<boolean>(false);
  const [addScanConfig, setAddScanConfig] = useState<EntryFieldConfig | null>(null);

  const fetchEntityNonInBodyConfig = async () => {
    try {
      setScanConfigLoading(true);
      const data = await inbodyDataService.getEntityInbodyData(entityId);

      setAddScanConfig(data.nonInbodyData);
    } finally {
      setScanConfigLoading(false);
    }
  };

  useEffect(() => {
    if (inBodyType === INBODY_TYPES.NON_INBODY) {
      fetchEntityNonInBodyConfig();
    } else {
      setAddScanConfig(inbodyEntryFieldConfig[inBodyType]);
    }
  }, []);

  return {
    addScanConfig,
    scanConfigLoading,
  };
};
